import script from "./transferFunds.vue?vue&type=script&setup=true&lang=js"
export * from "./transferFunds.vue?vue&type=script&setup=true&lang=js"

import "./transferFunds.vue?vue&type=style&index=0&id=6ac40979&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ac40979"]])

export default __exports__